import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins'
import vuetify from './plugins/vuetify'
import { sync } from 'vuex-router-sync'
import VueClipboard from 'vue-clipboard2'
import { SHOP_URL } from '@/config.env';

sync(store, router)

Vue.config.productionTip = false

Vue.prototype.$formatDate = (dateString, returnObject = false) => {
	const dateObject = new Date(dateString);

	if (returnObject) {
		return dateObject;
	}

	return dateObject.toLocaleDateString('ru-RU');
};

Vue.prototype.$formatDateTime = (dateString, returnObject = false) => {
	const dateObject = new Date(dateString);

	if (returnObject) {
		return dateObject;
	}

	return dateObject.toLocaleDateString('ru-RU') + ' ' + dateObject.toLocaleTimeString();
};

const baseShopUrl = SHOP_URL.endsWith('/') ? SHOP_URL : `${SHOP_URL}/`
Vue.prototype.$getShopUrl = url => {
	url = url.startsWith('/') ? url.substring(1) : url;
	return `${baseShopUrl}${url}`;
}

Vue.use(VueClipboard);

new Vue({
	router,
	store,
	vuetify,
	render: h => h(App),
}).$mount('#app')
